/**
 * Phones follow the hand (UI-011, owner 2026-09-27).
 *
 * On a phone the table's orientation is however the phone is held: upright gives a
 * portrait table with the controls below, sideways a landscape table with the controls
 * in a column beside it. The Portrait/Landscape setting still decides on a tablet or a
 * computer, where the window's shape says nothing about how the player is holding it.
 *
 * A phone is a touch screen whose SHORT side is under 600 CSS pixels: the screen, not
 * the window, so a narrow desktop window is not mistaken for one, and turning the phone
 * does not change the answer. Every phone is well under (an S25 Ultra is 384); the
 * smallest iPad is 744.
 */
import type { TableOrientation } from '../settings/settings.ts';

export const PHONE_MAX_SHORT_SIDE_PX = 600;

export function isPhone(
  screenWidthPx: number,
  screenHeightPx: number,
  coarsePointer: boolean,
): boolean {
  return coarsePointer && Math.min(screenWidthPx, screenHeightPx) < PHONE_MAX_SHORT_SIDE_PX;
}

/** The orientation to draw: the phone's own, or the player's setting everywhere else. */
export function effectiveOrientation(
  setting: TableOrientation,
  phone: boolean,
  viewportWidthPx: number,
  viewportHeightPx: number,
): TableOrientation {
  if (!phone) return setting;
  return viewportHeightPx >= viewportWidthPx ? 'portrait' : 'landscape';
}
